import styled from 'styled-components';

import { withTheme } from 'contexts/ThemeContext';

import Sidebar, { SideItem } from 'components/Sidebar';

/**
 * BaseSidebarFunnel
 * @component
 *
 */
const BaseSidebarFunnel = withTheme(styled(Sidebar)`
  overflow: hidden;
  width: 100%;
  height: 100%;
  background-color: ${({ themeColors }) => themeColors.secondary};
`);

export default BaseSidebarFunnel;

export const SideItemFunnel = styled(SideItem)`
  height: 68px;
  p {
    min-width: 300px;
  }
`;
